// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-check-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round'>
    <path
      strokeLinejoin='round'
      d='M1.031 12.719A4.784 4.784 0 0 1 7.69 8.32m-4.8-4.367a2.922 2.922 0 1 0 5.844 0 2.922 2.922 0 0 0-5.843 0z'
    />
    <path
      fill='currentColor'
      d='M12.75 8.5c1.068 0 2.042.395 2.79 1.045l-2.821 2.82-.887-.885a.488.488 0 0 0-.035-.032l-.078-.064-.042-.031-.075-.045a1 1 0 0 0-1.28 1.473l.064.078c.01.013.02.024.032.036l1.219 1.217a1.532 1.532 0 0 0 1.082.449l.024-.001.102-.005a1.53 1.53 0 0 0 .956-.442l2.907-2.909A4.25 4.25 0 1 1 12.75 8.5z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
